<template>
  <div class="select-list">
    <v-select
      class="select-list"
      label="text"
      :value="checklistValue.value"
      :options="getOptions"
      :reduce="(country) => country.value"
      :placeholder="checklistValue.fieldTip"
      @search="asyncFind"
      @input="onChangeFieldValue"
    >
    </v-select>
    <!-- <div><pre class="language-json"><code>getOptions: {{ getOptions  }}</code></pre></div> -->
    <!-- <div><pre class="language-json"><code>options: {{ options  }}</code></pre></div> -->
    <!-- <div><pre class="language-json"><code>optionsAvailable: {{ optionsAvailable  }}</code></pre></div> -->
    <!-- <div><pre class="language-json"><code>checklistValue: {{ checklistValue  }}</code></pre></div> -->
  </div>
</template>

<script>
export default {
  name: "FormFillFieldTypeList",
  components: {},
  props: {
    checklistValue: Object,
    options: Array,
  },
  data: function () {
    return {
      isOptionsAvailableLoaded: false,
      optionsAvailable: [],
      // selectedOption: null,
    };
  },
  created() {
    this.loadOptions();
  },
  computed: {
    getOptions() {
      if (this.isOptionsAvailableLoaded == true) {
        return this.optionsAvailable;
      }
      return this.options;
    },
  },
  methods: {
    asyncFind(keyword) {
      let ret = [];
      let founded = [];
      let items = this.options;

      if (keyword != null && items != null && keyword.trim() != "") {
        keyword.split(" ").forEach((k) => {
          let i = 0;
          items.forEach((item) => {
            if (
              k.trim() != "" &&
              item.text.toString().toLowerCase().startsWith(k.toLowerCase())
            ) {
              ret.push(item);
              founded.push(item);
            }
            i++;
          });
          i = 0;
          items.forEach((item) => {
            if (!ret.includes(item)) {
              if (
                k.trim() != "" &&
                item.text.toString().toLowerCase().includes(k.toLowerCase())
              ) {
                ret.push(item);
              }
            }
            i++;
          });
        });

        // this.optionsAvailable = ret;
        this.optionsAvailable = this.distinctOptionsList(ret);
        this.isOptionsAvailableLoaded = true;
      } else {
        // this.optionsAvailable = items;
        this.optionsAvailable = this.distinctOptionsList(items);
        this.isOptionsAvailableLoaded = true;
      }
    },
    distinctOptionsList(optionsList) {
      let distinctedList = [];
      for (let opt of optionsList) {
        let exists = false;
        for (let dist of distinctedList) {
          if (dist.value == opt.value) {
            exists = true;
          }
        }
        if (!exists) {
          distinctedList.push(opt);
        }
      }
      return distinctedList;
    },
    loadOptions() {
      this.isOptionsAvailableLoaded = false;
      this.optionsAvailable = [];

      if (!this.checklistValue) return;
      if (this.checklistValue == null) return;
      if (!this.options) return;
      this.isOptionsAvailableLoaded = true;
      this.optionsAvailable = this.distinctOptionsList(this.options);
    },
    onChangeFieldValue(value) {
      if (value) {
        this.checklistValue.value = value;
      } else {
        this.checklistValue.value = "";
      }
      this.$emit("onDataChange", this.checklistValue);
    },
  },
  watch: {
    checklistValue(newValue, oldValue) {
      this.loadOptions();
    },
    options(newValue, oldValue) {
      this.loadOptions();
    },
  },
};
</script>

<style scope>
.select-list {
  width: 100%;
}
</style>
